import { NoteInterface } from './../../components/Notes';
import { GET_NOTES, DELETE_NOTE, EDIT_NOTE, ADD_NOTE, EDITING_NOTE } from '../constants/index'
import Api from '../../services/Api'

const api = Api.getInstance();

export const getNotesAction = (payload: any) => {
	return {
		type: GET_NOTES,
		payload
	}
}

export const getNotes = (walkId: number) => (dispatch: any) => {
  api.get('notes/list/' + walkId).then(res => {
    res.json().then(data => {
      if(data.status === 'ok' && data.walks.length >= 0) {
        const notes = data.walks.length === 0 ? [] : data.walks[0].notes
        dispatch(getNotesAction(notes))
      }
    });
  });
}

export const deleteNoteAction = (payload: any) => {
  return {
    type: DELETE_NOTE,
    payload
  }
}

export const editNoteAction = (payload: NoteInterface) => {
  return {
    type: EDIT_NOTE,
    payload
  }
}

export const addNoteAction = (payload: NoteInterface) => {
  return {
    type: ADD_NOTE,
    payload
  }
}

export const editingNoteAction = (payload: editingInterface) => {
  return {
    type: EDITING_NOTE,
    payload
  }
}

export const editingAction = (walkId: number, note: NoteInterface) => (dispatch: any) => {
  api.post('notes/edit/' + walkId, note).then(res => {
    res.json().then(data => {
      dispatch(editingNoteAction({walkId: walkId, edit: note.edit}))
    })
  })
}

export interface editingInterface {
  walkId: number,
  edit: boolean
}